export type ConfirmOptions = {
  title: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'danger' | 'neutral';
};

type ConfirmFn = (options: ConfirmOptions) => Promise<boolean>;

let confirmImpl: ConfirmFn | null = null;

export function registerConfirm(fn: ConfirmFn | null) {
  confirmImpl = fn;
}

export function confirmAction(options: ConfirmOptions | string): Promise<boolean> {
  const resolved = typeof options === 'string' ? { title: options } : options;
  if (!confirmImpl) {
    return Promise.resolve(false);
  }
  return confirmImpl(resolved);
}
